import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col, Transfer } from 'antd';
import { useMediaQuery } from 'react-responsive'
import RequestHandler from '../../util/RequestHandler';
const userId = localStorage.getItem("userId");

const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const GroupAdd = () => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({ query: '(max-device-width: 1224px)' });
  const [mockDataTenant, setmockDataTenant] = useState([]);
  const [mockDataUser, setmockDataUser] = useState([]);
  const [targetKeysTenant, setTargetKeysTenant] = useState([]);
  const [loading, setLoading] = useState(false);
  const [targetKeysUser, setTargetKeysUser] = useState([]);

  useEffect(() => {
    RequestHandler.get(`/User/GetUserTenants/${userId}`).then(response => {
      getMockTenant(response);
      const tenantList = [];
      response.map((item) => {
        tenantList.push(item.id);
      });

      RequestHandler.post(`/User/GetUserListForTenants`, {
        tenants: tenantList
      }, false).then(res => {
        getMockUser(res)
      });
    });
  }, []);

  const onFinish = (values) => {
    const tenantList = [];
    const userList = [];
    targetKeysTenant.map((item) => {
      tenantList.push(item);
    })
    targetKeysUser.map((item) => {
      userList.push(item);
    })

    RequestHandler.post(`/Group`, {
      name: values.name,
      tenantIds: tenantList,
      userIds: userList
    }).then(res => {
      setTimeout(function () {
        window.location.reload();
      }.bind(this), 2000)
    });
  };

  const onFinishFailed = () => setLoading(false);

  const getMockTenant = (value) => {
    const targetKeysTenant = [];
    const mockDataTenant = [];
    value.map((item, index) => {
      const data = {
        key: item.id,
        title: item.name,
        description: ``,
      };
      if (data.chosen) {
        targetKeysTenant.push(data.key);
      }
      mockDataTenant.push(data);
    })
    setmockDataTenant(mockDataTenant)
    setTargetKeysTenant(targetKeysTenant)
  };

  const getMockUser = (value) => {
    const targetKeysUser = [];
    const mockDataUser = [];
    value.map((item, index) => {
      const data = {
        key: item.id,
        title: item.firstName,
        description: ``,
      };
      if (data.chosen) {
        targetKeysUser.push(data.key);
      }
      mockDataUser.push(data);
    })
    setmockDataUser(mockDataUser)
    setTargetKeysUser(targetKeysUser)
  };

  const filterOptionUser = (inputValue, option) => option.description.indexOf(inputValue) > -1;

  const handleChangeUser = targetKeysUser => {
    setTargetKeysUser(targetKeysUser)
  };

  const filterOptionTenant = (inputValue, option) => option.description.indexOf(inputValue) > -1;

  const handleChangeTenant = targetKeysTenant => {
    setTargetKeysTenant(targetKeysTenant)
  };

  return (
    <div>
      {isTabletOrMobileDevice && <>
        <Form
          {...layout}
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Grup Adı"
            name="name"
            rules={[
              {
                required: true,
                message: 'İsim alanını boş bırakmayın',
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Şirketler"
            name="users"
          >
            <Transfer
              dataSource={mockDataTenant}
              style={{ marginLeft: '-24%' }}

              showSearch
              locale={
                {
                  searchPlaceholder: "Arama Yapınız",
                  notFoundContent: 'Liste Boş',
                  itemUnit: 'Şirket',
                  itemsUnit: 'Şirket',
                  selectAll: 'Hepsini Seç',
                  selectInvert: 'Seçimleri Kaldır'
                }
              }
              listStyle={{
                width: 300,
                height: 250,
              }}
              titles={['(-)', '(+)']}
              filterOption={filterOptionTenant}
              targetKeys={targetKeysTenant}
              onChange={handleChangeTenant}
              render={item => item.title}
            />
          </Form.Item>

          <Form.Item
            label="Kullanıcılar"
            name="tenants"
          >

            <Transfer
              style={{ marginLeft: '-24%' }}
              dataSource={mockDataUser}
              showSearch
              locale={
                {
                  searchPlaceholder: "Arama Yapınız",
                  notFoundContent: 'Liste Boş',
                  itemUnit: 'Kullanıcı',
                  itemsUnit: 'Kullanıcı',
                  selectAll: 'Hepsini Seç',
                  selectInvert: 'Seçimleri Kaldır'
                }
              }
              listStyle={{
                width: 300,
                height: 250,
              }}
              filterOption={filterOptionUser}
              targetKeys={targetKeysUser}
              onChange={handleChangeUser}
              render={item => item.title}
            />
          </Form.Item>

          <Col span={20}>
            <Form.Item {...tailLayout}>
              <Button type="primary" style={{ marginLeft: '100%' }} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                Ekle
              </Button>
            </Form.Item>
          </Col>
        </Form>
      </>}
      {isDesktopOrLaptop && <>
        <Row>
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item
              label="Grup Adı"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'İsim alanını boş bırakmayın',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Şirketler"
              name="users"
            >
              <Transfer
                dataSource={mockDataTenant}
                showSearch
                locale={
                  {
                    searchPlaceholder: "Arama Yapınız",
                    notFoundContent: 'Liste Boş',
                    itemUnit: 'Şirket',
                    itemsUnit: 'Şirket',
                    selectAll: 'Hepsini Seç',
                    selectInvert: 'Seçimleri Kaldır'
                  }
                }
                listStyle={{
                  width: 300,
                  height: 250,
                }}
                titles={['(-)', '(+)']}
                filterOption={filterOptionTenant}
                targetKeys={targetKeysTenant}
                onChange={handleChangeTenant}
                render={item => item.title}
              />
            </Form.Item>
            <Form.Item
              label="Kullanıcılar"
              name="tenants"
            >
              <Transfer
                dataSource={mockDataUser}
                showSearch
                locale={
                  {
                    searchPlaceholder: "Arama Yapınız",
                    notFoundContent: 'Liste Boş',
                    itemUnit: 'Kullanıcı',
                    itemsUnit: 'Kullanıcı',
                    selectAll: 'Hepsini Seç',
                    selectInvert: 'Seçimleri Kaldır'
                  }
                }
                listStyle={{
                  width: 300,
                  height: 250,
                }}
                filterOption={filterOptionUser}
                targetKeys={targetKeysUser}
                onChange={handleChangeUser}
                render={item => item.title}
              />
            </Form.Item>

            <Form.Item {...tailLayout}>
              <Button type="primary" style={{ marginLeft: '100%' }} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                Ekle
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </>}
    </div>

  );
}

export default GroupAdd